
import React from "react";
import * as yup from 'yup';
import GQLChanges from '../../utils/graphql-changes';
import { Link } from 'react-router-dom';
import {
    User, UserQueryDocument, useUpdateUserMutationMutation, useUserQueryQuery,
} from "../../generated/graphql";
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import {SideList} from "../../components/SideList";

function newRow(): User {
  return {
    name: '',
    email: '',
    password: '',
    role: { id: 1, name: 'User Role' },
    salesTeams: []
  }
}

function convertVariables(initialValues, values) {
  const changes = new GQLChanges({
    role:'connect',
    salesTeams:'connect'
  });
  const ret = changes.compare(initialValues,values);
  return {input:ret};
}


const validationSchema = yup.object().shape({
  'users': yup.array().of(
    yup.object().shape({
      name: yup.string().min(3),
      email: yup.string().email().required(),
      password: yup.string().min(8)
      // if ID isn't a number, enforce a password
        /*.when(['id'], {
          is: (id:string) => !/^\d+$/.test(id),
          then:
            yup.string().required()
              .matches(
                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
              ),
          otherwise:
            yup.string().matches(
              /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
            )
        })*/
      })
  )
});


const columns: FieldTableColumnProps<User>[] = [
  {
    header: 'Name',
    accessor: 'name',
    dataType:'link',
    options: {
      getLink:({field,row})=> {
        return ({
          pathname: '/settings/users/' + row.id,
          search: (location.search ? location.search : '')
        });
      }
    }
  }, {
    header: 'Email',
    accessor: 'email',
    dataType:'default'
  },
   {
    header: 'Role',
    accessor: 'role',
    dataType:'select',
    readOnly: true,
    options: {
      label: 'name',
    }
  }, {
    header: 'Sales Teams',
    accessor: 'salesTeams',
    dataType:'select',
    sort:'salesTeam.name',
    options: {
      getValue: ({ field }) => '' + ((field.value && field.value.length) ? field.value.map((k) => { return k.name }).join(', ') : ''),
    }
  }
];



const Users = () => {
  /*return <ListEditor
    columns={columns}
    query={userQuery}
    mutation={userMutation}
    title="Manage Users"
    lookups={['salesTeams', 'role']}
    newRow={newRow}
    validationSchema={validationSchema}
    newRowLabel="Add new user" />;*/
    //const updatesMutation = useUserMutationMutation();
//    const updatesMutation = useMutation(userMutation);
    //const createMutation = useCreateUserMutationMutation();
    //const updateMutation = useUpdateUserMutationMutation();
//    useMutation(createUserMutation);
    //const updateMutation = useMutation(updateUserMutation);
    const mutation=useUpdateUserMutationMutation();
    return <SideList
        label="Users"
        className="users"
        permission="users"
        deleteMutation={mutation}
        simpleDelete={true}
        getResults={(e)=>e.users}
        query={UserQueryDocument}
        columns={columns}
        baseUrl="/settings/users/"
         mode={null}
     noEditorScroll={false}
        searchForm={null}
    />

/*
    return (<SideEditorFull
      label="Users"
      className="users"
      getResults={(e) => e.options}
      query={UserQueryDocument}
      columns={columns}
      permission="users"
      baseUrl="/settings/users/"
      updateMutation={updatesMutation}
      editorProps={{
          className: 'user__editor',
          createMutation:createMutation,
          updateMutation:updateMutation,
          //combinedMutation:updateMutation,
          lookupColumns:[],
          // eslint-disable-next-line react/display-name
          form: (args) => {
              return <UserForm {...args} />;
          },
          getQuery: GetUserQueryDocument,
          getDataFromGraphql: (v) => {
              return v.user;
          },
          getIdFromResult: (v) => {
              return v.createUser.id;
          },
          convertVariables: convertVariables,
          validationSchema: validationSchema,
          blankValues: newRow
      }}
      />);
*/

};

export default Users;
